export var AppState;
(function (AppState) {
    /// <summary>
    /// The app is running in the background. It is not visible to the user (eg. hidden behind another app or minimized).
    /// In this state app should not perform any heavy operations. It can be disconnected from the server.
    /// The app should show that it is inactive and disconnected from the controller.
    /// </summary>
    AppState[AppState["Suspended"] = 1] = "Suspended";
    /// <summary>
    /// The app returnet brom background and is running in the foreground. It is visible to the user.
    /// In this state app can perform any operations.
    /// The app should reconnect and loggin again and show that it is active and connected to the controller.
    /// </summary>
    AppState[AppState["ReturnedFromSuspension"] = 2] = "ReturnedFromSuspension";
    /// <summary>
    /// The app is running in low pawer mode. In that mode app should not perform any heavy operations. It can be disconnected from the server.
    /// In this state app should show that it is inactive and disconnected from the controller. (similar to "suspended" state but with lower power consumption in mind and can be entered manually and is not depended on app visibility to the user.)
    /// </summary>
    AppState[AppState["EnteredLowPowerMode"] = 3] = "EnteredLowPowerMode";
    /// <summary>
    /// The app returned from low power mode and is running in normal mode. It can perform any operations.
    /// In this state app should reconnect and loggin again and show that it is active and connected to the controller. (similar to "returned from suspension" state and can be entered manually and is not depended on app visibility to the user.)
    /// </summary>
    AppState[AppState["ExitedLowPowerMode"] = 4] = "ExitedLowPowerMode";
    /// <summary>
    /// App session is active. User is logged in and connected to the controller.
    /// App can perform any operations on controller in the context of the user.
    /// </summary>
    AppState[AppState["LoggedIn"] = 5] = "LoggedIn";
    /// <summary>
    /// App session is inactive. User is logged out.
    /// The app should show that the user is logged out. it can be still conncecet to the controller. 
    /// This can happen for example, when user is logged out from another device.
    /// </summary>
    AppState[AppState["LoggedOut"] = 6] = "LoggedOut";
    /// <summary>
    /// App is connected to the controller.
    /// The app should show that it is connected to the controller and can (or will in a second) login to the controller.
    /// </summary>
    AppState[AppState["Connected"] = 7] = "Connected";
    /// <summary>
    /// App is disconnected from the controller and logged out.
    /// The app should show that it is disconnected from the controller and logged out.
    /// </summary>
    AppState[AppState["Disconnected"] = 8] = "Disconnected";
    /// <summary>
    /// App failed to connect to the controller.
    /// The app should show that it is disconnected from the controller and logged out and cannot connect to the controller.
    /// </summary>
    AppState[AppState["FailedToConnect"] = 9] = "FailedToConnect";
    /// <summary>
    /// App is connecting to the controller.
    /// The app should show that it is connecting to the controller.
    /// </summary>
    AppState[AppState["Connecting"] = 10] = "Connecting";
    /// <summary>
    /// App is disconnecting from the controller.
    /// The app should show that it is disconnecting from the controller.
    /// </summary>
    AppState[AppState["Disconnecting"] = 11] = "Disconnecting";
    /// <summary>
    /// App is reconnecting to the controller.
    /// The app should show that it is reconnecting to the controller.
    /// </summary>
    AppState[AppState["Reconnecting"] = 12] = "Reconnecting";
})(AppState || (AppState = {}));
//# sourceMappingURL=IAppStateService.js.map